import { render } from "./LemmasMiniGuide.vue?vue&type=template&id=09f9933f"
import script from "./LemmasMiniGuide.vue?vue&type=script&lang=js"
export * from "./LemmasMiniGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__